import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { SnackBarService } from '../../services/snack-bar-service.service';
import { AdmRedePostosServices } from '../adm-rede-postos.service';
import { AdmRedePosto, UsuarioMasterInterface } from '../macro-posto.interface';

@Component({
  selector: 'app-remover-usuario-master',
  templateUrl: './remover-usuario-master.component.html',
  styleUrls: ['./remover-usuario-master.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatSpinnerOverlayComponent,
  ],
})
export class RemoverUsuarioMasterComponent {
  public dialogRef = inject(MatDialogRef<RemoverUsuarioMasterComponent>);
  private snack = inject(SnackBarService);
  service: AdmRedePostosServices = inject(AdmRedePostosServices);
  public loading: boolean = false;
  @Output() removerUsuario = new EventEmitter<string>();
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      usuario: UsuarioMasterInterface;
      admRedePosto: AdmRedePosto;
    }
  ) {}

  onCancelar(): void {
    this.dialogRef.close(false);
  }

  onConfirmar(): void {
    this.loading = true;
    const payload: any = {
      codLogin: this.data.usuario.codLogin,
      codPerfil: this.data.usuario.codPerfil,
      dscLogin: this.data.usuario.dscLogin || '',
      codEntidade: this.data.admRedePosto.codEntidade,
      DscIdentificacao: this.data.admRedePosto.nome,
    };

    this.service.desativarLogin(payload).subscribe({
      next: (response) => {
        if (response && response.sucesso) {
          this.removerUsuario.emit(`remove`);

          this.dialogRef.close(true);
        } else {
          throw new Error('Falha ao desativar usuário');
        }
      },
      error: (error) => {
        this.snack.flashMessage(
          error?.mensagens[0] || 'Erro ao desativar usuário',
          ['snackbar-error'],
          'Fechar',
          3000
        );
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
//RemoverUsuarioMasterComponent e EditarUsuarioMasterComponent
